export default {
  courseOutlineRegistration: {
    id: '',
    academicPeriodId: '',
    periodCode: '',
    courseOutlineId: '',
    degreeId: '',
    subjectGroupId: '',
    subjectId: '',
    subjectCode: '',
    subjectName: '',
    teacherId: '',
    teacherCode: '',
    classSections: [],
  },
  courseOutlineRegistrations: [],
  processing: false,
  error: null,
  success: null,
}



